import React, { Component, PropTypes } from 'react'
import styles from './Introduction.css'
import * as mpLoyalty from 'mixpanel/customers/loyalty'
import ReactPlayer from 'react-player'

class Introduction extends Component {

  componentDidMount () {
    mpLoyalty.loyaltyStart()
  }

  render () {
    return (
      <div className={`${styles['splash-page']} ${styles['gray-backgrond']}`}>
        <div className='splash-box'>
          <div id={styles.create} className={styles['splash-content']}>
            <div id={styles.introduction}>
              <p style={{marginBottom: '25px'}} className='text-center'>
                <img className='img-circle' src={require('assets/images/ic-loyalty.png')} />
              </p>

              <h4 className={`text-center ${styles['title']}`}>
                Loyalty Program Feature
              </h4>

              <p className={`text-center ${styles['body-content']}`}>
                Set up your Loyalty Program today and keep your customers coming back for repeat purchases!<br /><br />
                Loyalty Program will be implemented to all<br />your active outlets.
              </p>

              <ReactPlayer url='https://www.youtube.com/watch?v=iwIe4tpGK7Q&feature=youtu.be'
                height='146px'
                width='248px'
                className={styles['video-content']}
                playing={false}
                controls
                onPlay={this._onVideoPlay}
              />

              <button
                onClick={this._onClickCreateLoyaltyProgram}
                className={`btn btn-primary btn-block ${styles['create-button']}`}
              >
                Create a Loyalty Program
              </button>
              <div className={styles.compatibility}>
                <b>Compatibility:</b> Requires Moka App v7.0 (android tablet only) or v12.8 (iOS) or newer.
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onVideoPlay = () => {
    mpLoyalty.loyaltyVideoStart()
  }

  _onClickCreateLoyaltyProgram = () => {
    this.props.goToCreateView()
  }
}

Introduction.propTypes = {
  goToCreateView: PropTypes.func.isRequired
}

export default Introduction



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Introduction/Introduction.js